<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('addCustomer')">
      <v-btn class="sf-back-btn"
             exact
             slot="left-button"
             text
             v-bind:to="{ name: 'administration-customers' }">
        <v-icon left>ti-arrow-left</v-icon>
        {{ $t('back') }}
      </v-btn>
      <v-btn color="primary"
             depressed
             exact
             slot="right-button"
             v-on:click="createCustomer">
        <v-icon left>ti-check</v-icon>
        {{ $t('add') }}
      </v-btn>
    </top-header>
    <div class="sf-container">
      <v-alert class="sf-alert"
               text
               type="error"
               v-model="validationAlert">
        {{ $t('pleaseCompleteTheForm') }}
      </v-alert>
      <v-row>
        <v-col cols="12"
               lg="8">
          <customer-edit-card ref="customerEditForm"
                              v-bind:customer="customer" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import CustomerEditCard from '@/components/administration/CustomerEditCard'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      CustomerEditCard,
      TopHeader
    },
    data: () => ({
      customer: {
        state: 'open'
      },
      validationAlert: false
    }),
    methods: {
      async createCustomer() {
        if (!this.$refs.customerEditForm.validate()) {
          this.validationAlert = true
          this.$vuetify.goTo(0)

          return
        }

        await this.$store.dispatch('createCustomer', { customer: this.customer })

        this.$router.push({ name: 'administration-customer', params: { id: this.customer.id } })
      }
    },
    name: 'AddCustomer'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Hinzufügen",
      "addCustomer": "Kunde hinzufügen",
      "back": "Zurück",
      "pleaseCompleteTheForm": "Bitte vervollständigen Sie Ihre Angaben."
    },
    "en": {
      "add": "Add",
      "addCustomer": "Add customer",
      "back": "Back",
      "pleaseCompleteTheForm": "Please complete the form."
    }
  }
</i18n>